<template>
  <!--
    Unlocked fork: the "billable" seat badge (and its link to Baserow's
    subscriptions docs) was removed — there are no paid seats to bill for.
  -->
  <div v-if="roleUID" class="highest-role-field">
    {{ roleName }}
  </div>
</template>

<script>
export default {
  name: 'HighestPaidRoleField',
  props: {
    row: {
      required: true,
      type: Object,
    },
    column: {
      required: true,
      type: Object,
    },
  },
  computed: {
    roleUID() {
      return this.row[this.column.key]
    },
    roleName() {
      return this.role ? this.role.name : ''
    },
    role() {
      return this.roles.find((r) => r.uid === this.roleUID)
    },
    workspace() {
      return this.$store.getters['workspace/get'](
        this.column.additionalProps.workspaceId
      )
    },
    roles() {
      // filters out role not for Team subject and not for workspace level
      return this.workspace?._.roles || []
    },
  },
  methods: {
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1)
    },
  },
}
</script>
